module.exports = __webpack_public_path__ + "img/shop02.7d981b90.jpg";